import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, geoJSONFileColumn } from "./ColumnHelpers";

export function column_PointsGeoJSON(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return geoJSONFileColumn(context, "pointsOptions", "pointsGeoJSON", "pointsGeoJSON");
}
